<div class="row">
	<div class="col-11"></div>
	<div class="col text-end">
		<button mat-mini-fab (click)="cancel()">
			<mat-icon>close</mat-icon>
		</button>
	</div>
</div>
<div class="row" style="margin-left: 10px;">
	<mat-tab-group style="width: 99%">
		<mat-tab label="Contact Info">
			<form [formGroup]="contactInfoForm" style="margin-top: 10px;">
				<div class="row">

					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
						<mat-form-field>
							<mat-label>Username</mat-label>
							<input matInput placeholder="Enter UserName..." [value]="user.USER_ID" readonly="true">
						</mat-form-field>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
						<mat-form-field>
							<mat-label>Work Email</mat-label>
							<input matInput placeholder="Enter Work Email..." [value]="user.EMAIL_ADDRESS"
								readonly="true">
						</mat-form-field>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
						<mat-form-field>
							<mat-label>Account Created</mat-label>
							<input matInput placeholder="" [value]="user.CREATED_DATE | shortDateTime" readonly="true">
						</mat-form-field>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
						<mat-form-field>
							<mat-label>Last Login</mat-label>
							<input matInput placeholder="" [value]="user.LOGIN_AUDITS[0]?.LOGIN_TIME | shortDateTime"
								readonly="true">
						</mat-form-field>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
						<mat-accordion class="headers-align">
							<mat-expansion-panel [disabled]="!(accessService.hasAccess('Edit Account Status') | async)">
								<mat-expansion-panel-header>
									<mat-panel-title>
										Account Status
									</mat-panel-title>
									<mat-panel-description>
										<span [ngClass]="{ 
										'theme-font-color': loginDetailStatusName == 'Active', 
										'warn-font-color': !(loginDetailStatusName == 'Active') }">
											{{loginDetailStatusName}}
										</span>
										<mat-icon>edit</mat-icon>
									</mat-panel-description>
								</mat-expansion-panel-header>

								<div class="row">
									<mat-form-field>
										<mat-label>Account Status</mat-label>
										<mat-select formControlName="accountStatus" id="accountStatus"
											(selectionChange)="onStatusChange($event)">
											<mat-option [disabled]="!editAccountStatus" *ngFor="let statusType of loginDetailStatusType | slice:0:2 "
												[value]="statusType.ID">
												{{statusType.DESCRIPTION}}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="row">
									<mat-form-field *ngIf="revokeCtrHide">
										<mat-label>Revoked by</mat-label>
										<mat-select formControlName="reasonRevoking" id="reasonRevoking">
											<mat-option [disabled]="!editAccountStatus"
												*ngFor="let statusType of loginDetailStatusType | slice:2:5 | orderBy:'DESCRIPTION'"
												[value]="statusType.ID" [disabled]="statusType.ID===3 || (statusType.ID==5 && !systemAdministratorUser)">
												{{statusType.DESCRIPTION}}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="row">
									<mat-form-field *ngIf="revokeCtrHide">
										<mat-label>Enter a reason for revoking the account</mat-label>
										<textarea [disabled]="!editAccountStatus" formControlName="reasonComment" id="reasonComment" matInput
											placeholder=""></textarea>
									</mat-form-field>
								</div>

							</mat-expansion-panel>
						</mat-accordion>
						<br>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
						<mat-form-field>
							<mat-label>Account Status Modified Date</mat-label>
							<input matInput placeholder=""
								[value]="user.LOGIN_DETAIL_STATUS[0].CREATED_DATE | shortDateTime" readonly="true">
						</mat-form-field>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
						<mat-form-field>
							<mat-label>Account Status Modified By</mat-label>
							<input matInput placeholder="" [value]="user.LOGIN_DETAIL_STATUS[0].CREATED_BY"
								readonly="true">
						</mat-form-field>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
						<mat-form-field>
							<mat-label>Password changed on </mat-label>
							<input matInput placeholder=""
								[value]="passwordChangeInformation?.lastPasswordChangeDate | longDateTime"
								readonly="true">
						</mat-form-field>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
						<mat-form-field>
							<mat-label>Password expires on</mat-label>
							<input matInput placeholder=""
								[value]="passwordChangeInformation?.nextPasswordChangeDate | longDateTime"
								readonly="true">
						</mat-form-field>
					</div>
				</div>
				<div>
					<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-2">
							<mat-form-field>
								<mat-label>Person's First Name </mat-label>
								<input formControlName="firstName" id="firstName" matInput
									placeholder="Enter the First Name">
							</mat-form-field>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-1">
							<mat-form-field>
								<mat-label>M.I.</mat-label>
								<input formControlName="middleName" id="middleName" matInput
									placeholder="Enter the Middle Name">
							</mat-form-field>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-2">
							<mat-form-field>
								<mat-label>Person's Last Name</mat-label>
								<input formControlName="lastName" id="lastName" matInput
									placeholder="Enter the Last Name">
							</mat-form-field>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-1">
							<mat-form-field>
								<mat-label>Suffix</mat-label>
								<mat-select formControlName="suffix" id="suffix">
									<mat-option value=""></mat-option>
									<mat-option value="Jr">Jr</mat-option>
									<mat-option value="Sr">Sr</mat-option>
									<mat-option value="II">II</mat-option>
									<mat-option value="III">III</mat-option>
									<mat-option value="IV">IV</mat-option>
									<mat-option value="V">V</mat-option>
									<mat-option value="VI">VI</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>

					<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
							<mat-form-field>
								<mat-label>Work Title </mat-label>
								<input formControlName="workTitle" id="workTitle" matInput placeholder="">
							</mat-form-field>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
							<mat-form-field>
								<mat-label>Work Email </mat-label>
								<input formControlName="workEmail" id="workEmail" matInput placeholder="">
							</mat-form-field>
						</div>
					</div>
				</div>
				<mat-divider></mat-divider>
				<div class="row">
					<app-address [type]="'People'" [filterTypes]="['Work Address']" [data]="partyContactMechanisms"
						[editing]="editAccountContactInformation" (partyContactMechanismsChange)="pcmNotificationChange($event,'Address')">
					</app-address>
				</div>
				<mat-divider></mat-divider>
				<div class="row">
					<app-phone [type]="'People'" [filterTypes]="[ 'Cell Phone', 'Other Phone','Work Phone']"
						[editing]="editAccountContactInformation" [data]="partyContactMechanisms"
						(partyContactMechanismsChange)="pcmNotificationChange($event,'Phone')">
					</app-phone>
				</div>
			</form>
		</mat-tab>


		<mat-tab label="Regions/Organization">
			<div class="row" style="margin-top: 10px;">
				<div class="col-3">
					<region-dropdown-two-way [isMultiple]="false" [(selectedRegions)]="selectedRegions"
						[(selectedRegion)]="selectedRegion">
					</region-dropdown-two-way>
				</div>

				<div class="col-3">
					<district-dropdown-two-way #districtDropDown [(selectedSchoolDistricts)]="lstSelecteddistricts"
						[isMultiple]="true" [regions]="selectedRegions">
					</district-dropdown-two-way>
				</div>
			</div>

			<div class="row">
				<div class="col-6">
					<div class="row">
						<div class="col">
							<span *ngIf="!user.REGION?.ID">
								Organization that user works for : {{selectedOrganization.NAME}}
							</span>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<span *ngIf="user.REGION?.ID">
								Organization that user works for in Region : {{user.REGION?.NAME}}
							</span>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<input-organization-autocomplete [id]="'Organization'" [name]="'Organization'"
								[label]="'Organization'" [placeholder]="'Type minimum 3 character to Search..'"
								[(selectedOrganization)]="selectedOrganization" [(region)]="selectedRegion"
								[required]="true"
								[additionalErrorMsg]="'User is required to have a Region or Works for an Organization'">
							</input-organization-autocomplete>
						</div>
					</div>
				</div>
				<div class="col">

					<mat-chip-listbox>
						<mat-chip-option color="accent" *ngFor="let district of lstSelecteddistricts"
							(removed)="removeDistrict(district.ID)">
							{{district.DISTRICTS}}

							<button matChipRemove>
								<mat-icon>cancel</mat-icon>
							</button>
						</mat-chip-option>

					</mat-chip-listbox>

				</div>

			</div>

			<div class="row">

				<div class="col-3">

				</div>
				<div class="col-3">
				</div>

			</div>
		</mat-tab>


		<mat-tab label="Role">
			<h2>User's Roles  </h2>
			<mat-divider></mat-divider>

			<mat-card>
				<mat-card-title>
					Please select all that apply
				</mat-card-title>
				<mat-card-content>
					<div class="row">
						<ng-container *ngFor="let usrRole of lstUserRoles; let i=index">
							<div class="col-4">
								<mat-checkbox id="role-{{usrRole.role.ID}}" name="role-{{usrRole.role.ID}}"
									[(ngModel)]="usrRole.selected" (change)="onChkChange($event,usrRole.role)"
									color="primary">
									{{ usrRole.role.NAME }}
								</mat-checkbox>
							</div>
						</ng-container>
					</div>
				</mat-card-content>
			</mat-card>

			<mat-card>
				<mat-card-title>
					Approver Roles 
				</mat-card-title>
				<mat-card-content>
					<div class="row">
						<ng-container *ngFor="let approverRole of lstApproverRole; let i=index">
							<div class="col-4">
								<mat-checkbox id="role-{{approverRole.role.ID}}" name="role-{{approverRole.role.ID}}"
									[(ngModel)]="approverRole.selected" (change)="onChkChange($event,approverRole.role)"
									color="primary">
									{{ approverRole.role.NAME }}
								</mat-checkbox>
							</div>
						</ng-container>
					</div>
				</mat-card-content>
			</mat-card>

			<mat-card>
				<mat-card-title>
					Administrator Roles
				</mat-card-title>
				<mat-card-content>
					<div class="row">
						<ng-container *ngFor="let adminRole of lstAdminRoles; let i=index">
							<div class="col-4">
								<mat-checkbox id="role-{{adminRole.role.ID}}" name="role-{{adminRole.role.ID}}"
									[(ngModel)]="adminRole.selected" (change)="onChkChange($event,adminRole.role)"
									color="primary">
									{{ adminRole.role.NAME }}
								</mat-checkbox>
							</div>
						</ng-container>
					</div>
				</mat-card-content>
			</mat-card>
		</mat-tab>


	</mat-tab-group>
</div>
<div class="row" style="padding-top: 5px;">
	<fieldset
		[disabled]="(!this.editAccountStatus && !this.editAccountContactInformation)">

		<div class="row">

			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
				<b *ngIf="success.length>0" class="theme-font-color">
					{{this.success}}
				</b>
			</div>
			<div class="col text-end" style="margin-right: 1%;">
				<button mat-raised-button color="primary" type="button" (click)="save()" [disabled]="isDisabled()">
					<mat-icon *ngIf="isSaving">
						<mat-spinner color="warn" diameter="20"> </mat-spinner>
					</mat-icon>
					Save
				</button>
				<button mat-raised-button color="accent" (click)="reset()"> Reset</button>
			</div>
		</div>
	</fieldset>
</div>